import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

const NameEntry = () => {
    const navigate = useNavigate();
    const [displayName, setDisplayName] = useState('');
    const [error, setError] = useState(null);
    const [authUser, setAuthUser] = useState(null);
    const [checkingAuth, setCheckingAuth] = useState(true);

    useEffect(() => {
        // Check auth immediately without blocking
        if (auth.currentUser) {
            setAuthUser(auth.currentUser);
            setCheckingAuth(false);
            return;
        }
        
        const unsub = onAuthStateChanged(auth, (user) => {
            if (!user) {
                navigate('/login', { replace: true });
                return;
            }
            setAuthUser(user);
            setCheckingAuth(false);
        });
        return () => unsub();
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!displayName.trim()) {
            setError('Please enter a display name');
            return;
        }

        if (!authUser) {
            setError('Not authenticated. Please sign in again.');
            navigate('/login');
            return;
        }

        // Store name in sessionStorage and navigate to role selection
        sessionStorage.setItem('setupDisplayName', displayName.trim());
        navigate('/select-role', { replace: true });
    };

    if (checkingAuth) {
        return (
            <div className="min-h-screen bg-[#0e0e0e] text-white flex items-center justify-center">
                <div>Loading...</div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#0e0e0e] text-white flex items-center justify-center px-4">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <h1 className="text-3xl font-bold mb-2">Enter Your Name</h1>
                    <p className="text-white/70">What should we call you?</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                    {error && (
                        <div className="bg-red-500/10 border border-red-500/50 rounded-lg p-4 text-red-200 text-sm">
                            {error}
                        </div>
                    )}

                    <div>
                        <label htmlFor="displayName" className="block text-sm font-medium mb-2">
                            Display Name
                        </label>
                        <input
                            id="displayName"
                            type="text"
                            value={displayName}
                            onChange={(e) => setDisplayName(e.target.value)}
                            placeholder="Enter your display name"
                            className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-red-500/50"
                            required
                            autoFocus
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-gradient-to-br from-[#ff3b3b] to-[#ff0000] text-white font-semibold py-3 rounded-lg shadow-[0_8px_30px_rgba(255,0,0,0.35)] ring-1 ring-red-500/30 hover:opacity-90 transition"
                    >
                        Continue
                    </button>
                </form>
            </div>
        </div>
    );
};

export default NameEntry;

